// extracted by mini-css-extract-plugin
module.exports = {"primary":"#d6091e","chartBlue":"#2e869e","chartOrange":"#a24e15","chartYellow":"#9d892c","chartRed":"#812517"};